import gql from "graphql-tag";

export default gql`
query getSidebar {
    sidebar @client {
       display 
    }
}`;



// WEBPACK FOOTER //
// ./src/queries/getSidebar.ts